<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    :help-text="helpText"
    @change="handleInput"
  >
    <option
      v-for="options in options"
      :value="options.id"
      :key="options.id"
    >{{ options.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterSequences",
  props: {
    label: {
      type: String,
      default: "Sequences"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    helpText: String,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].sequences;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sequences",
          value
        ]);
      }
    },
    options() {
      return [
        {id: null, label: "No filter"},
        ...this.$store.getters.fusTemplates,
        {id: -1, label: "No Sequences"},
        {id: -2, label: "All Sequences"}
      ];
    },
    text() {
      if (this.filterValue) {
        if (this.filterValue === -1) {
          return "No Sequences";
        } else if (this.filterValue === -2) {
          return "All Sequences";
        } else {
          let template = this.$store.getters.fusTemplates.find(template => template.id === this.filterValue);
          return "Only " + template.label;
        }
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
